import withContextualSidebar from '../ContextualSidebarContainer';

export default withContextualSidebar(() => null);
